export default [
  {
    key: 'title',
    label: 'field.groupName',
    rules: 'required|min:2|max:50',
    type: 'text',
    cols: 12,
    translation: true,
  },
]
